export const SponsorAdManagementIcon = ({
  className,
}: {
  className?: string
}) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 21H14C19 21 21 19 21 14V8C21 3 19 1 14 1H8C3 1 1 3 1 8V14C1 19 3 21 8 21Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3396 6.03498C15.5185 5.97025 15.7193 5.9962 15.8751 6.10583C16.031 6.21451 16.1249 6.3939 16.1249 6.58492V14.7824C16.1248 14.9733 16.031 15.1518 15.8751 15.2615C15.7193 15.3713 15.5186 15.3982 15.3396 15.3324L8.99488 13.0257H8.11833L9.07653 16.3782L7.95023 16.7L6.90078 13.0257H5.58596C5.26337 13.0257 5.00026 12.7635 5 12.441V8.92758C5 8.60373 5.26321 8.34161 5.58596 8.34161H8.99488L15.3396 6.03498ZM9.68531 9.33703V12.0303L14.9542 13.9467V7.42064L9.68531 9.33703ZM6.17193 11.8538H8.51338V9.51234H6.17193V11.8538Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.245913"
      />
    </svg>
  )
}
